// Components
import { ReactComponent as Logo } from './../../assets/icons/bagstage-logo.svg';
import { ReactComponent as ArrivalIcon } from './../../assets/icons/xeu-arrival-icon.svg';
import { Clock } from './Clock';
import { HeaderLabel } from './HeaderLabel';
// Types
import { ArrivalBeltName, HeaderLabelContent } from '../../types';
// Styles
import headerStyles from '../../styles/Header.module.css';
import { getBeltLabel } from '../../service/beltDisplayNameService';
import UrlParam from '../../utils/urlParams';
import Labels from '../../utils/labels';
import { useAppSelector } from '../../store/hooks';

export const Header = () => {
	const belt = UrlParam.beltParamInUrl?.toUpperCase() as ArrivalBeltName;
	const beltRef = UrlParam.beltRefParamInUrl?.toUpperCase() as ArrivalBeltName;
	const isStaging = UrlParam.isStaging;

	const { currentBelt } = useAppSelector((state) => state.beltStore);

	const getHeaderLabelContent = (): HeaderLabelContent | undefined => {
		if (document.location.pathname === '/aeu') {
			return {
				title: 'Arrival',
				bgColor: '--purple',
				fontColor: '--white',
				beltLabel: currentBelt,
				icon: <ArrivalIcon width={40} height={40} />,
				dotType: 'white-dot'
			};
		} else if (document.location.pathname.toLocaleLowerCase() === '/oeu') {
			return {
				title: 'Oddsize',
				fontColor: '--white',
				icon: <ArrivalIcon width={40} height={40} />,
				beltLabel: getBeltLabel(belt ?? beltRef)
			};
		}
	};

	return (
		<div className={headerStyles.header}>
			<Logo height={50} width={220} />
			{isStaging && <div className="red-striped-container">{Labels.testSystem}</div>}
			<HeaderLabel headerLabelContent={getHeaderLabelContent()!} />
			<div className="flex gap-10">
				<Clock />
			</div>
		</div>
	);
};
